// 对应后端 cn.edu.sdu.web.controller.server.entity.MsgTypeEnum
const msgType = {
  TXT: 0,
  ARTICLE: 1,
  IMG: 2,
  VIDEO: 3,
  AUDIO: 4,
};

export default msgType;
